/* eslint-disable react-hooks/exhaustive-deps */
import { FormikProps, useFormik } from 'formik';
import React from 'react';
import { Button, Grid, TextField } from 'src/components';
import ParametreGrupEnum from 'src/enums/ParametreGrupEnum';
import { translate } from 'src/i18n/tHelper';
import VwGnlMesajDTO from 'src/models/Mesaj/VwGnlMesajDTO';
import GnlParametreSelect from 'src/parts/Genel/gnl.parametre.select';
import { useAppDispatch, useAppSelector } from 'src/store';
import { MesajSlice } from 'src/store/Slices/Mesaj/MesajSlice';
import MesajTipAutocomplete from '../MesajTipAutocomplete';
import { useMesajEkleMutation, useMesajGuncelleMutation } from 'src/services/Mesaj/MesajApi';
import * as yup from 'yup';
import PersonelAutoCompleteMulti from 'src/parts/Personel/personel.autocomplete.multi';
import ModulMultiAutocomplete from 'src/parts/Genel/ModulMultiAutoComplete';
import { Alert } from '@mui/material';
import AlertTitle from 'src/components/AlertTitle';
interface IMesajEkleProps {
    modulRow: boolean; //Modül mesajı ise true Row mesajı ise false
    initialValues: VwGnlMesajDTO;
    readOnly: boolean;
    closeHandler: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};
const translatePath = "parts|mesaj";
let formik: FormikProps<VwGnlMesajDTO> = null;
/**
 * Hasta müracaat veya modül bazlı mesaj eklenen component
 * @param props 
 * @returns 
*/
const MesajEkle = (props: IMesajEkleProps): JSX.Element => {
    const { initialValues, readOnly, closeHandler } = props;
    const state = useAppSelector(s => s.mesaj);
    const organizasyon = useAppSelector(s => s.userOrganizasyon.organizasyon);
    const dispatch = useAppDispatch();

    const [ekle, ekleState] = useMesajEkleMutation();
    const [guncelle, guncelleState] = useMesajGuncelleMutation();

    formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validateOnChange: false,
        onSubmit: async (values) => {
            if (values.id > 0) {
                await guncelle(values).unwrap().then(() => {
                    dispatch(MesajSlice.actions.setModulListeFetching(true));
                    dispatch(MesajSlice.actions.setModulActiveRow(new VwGnlMesajDTO()));
                    dispatch(MesajSlice.actions.setActiveRow(new VwGnlMesajDTO()));
                    dispatch(MesajSlice.actions.setModulOpen(false));
                    dispatch(MesajSlice.actions.setEditMode(false));
                }).catch(e => e);
                return;
            }
            await ekle({ ...values, organizasyonId: organizasyon.fkOrganizasyon, muracaatId: state.muracaatId }).unwrap().then(() => {
                dispatch(MesajSlice.actions.setModulListeFetching(true));
                dispatch(MesajSlice.actions.setModulActiveRow(new VwGnlMesajDTO()));
                dispatch(MesajSlice.actions.setActiveRow(new VwGnlMesajDTO()));
                dispatch(MesajSlice.actions.setModulOpen(false));
                dispatch(MesajSlice.actions.setEditMode(false));
            }).catch(e => e);
        },
        validationSchema: yup.object().shape({
            mesajturId: yup.number().required(translate(translatePath, "Zorunlu alan")),
            mesajtip: yup.number().required(translate(translatePath, "Zorunlu alan")),
            fkAlanIds: yup.string().trim().required(translate(translatePath, "Zorunlu alan")),
            baslik: yup.string().trim().min(5, translate(translatePath, "Minimum 5 karakter girmelisiniz")).required(translate(translatePath, "Zorunlu alan")),
            icerik: yup.string().trim().min(5, translate(translatePath, "Minimum 5 karakter girmelisiniz")).required(translate(translatePath, "Zorunlu alan")),
        })
    });
    /**
     * Mesaj kaydetmek için kullanılan fonksiyon
     * @param event 
    */
    const saveHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        if (!ekleState.isLoading && !guncelleState.isLoading)
            formik.submitForm();
    };
    return (
        <Grid container justifyContent="flex-end">
            {formik.values?.muracaatId > 0 && (
                <Grid item>
                    <Alert severity="info">
                        <AlertTitle>{translate(translatePath, "Hastaya Eklenen Mesaj")}</AlertTitle>
                        {`${formik.values?.hastaAdiSoyadi} (${translate(translatePath, "Müracaat No")}: ${formik.values?.muracaatId})`}
                    </Alert>
                </Grid>
            )}
            <Grid item md={4}>
                <GnlParametreSelect
                    readOnly={readOnly}
                    required={true}
                    parametreType={ParametreGrupEnum.GenelMesajTurleri}
                    label={translate(translatePath, "Mesaj Türü")}
                    name="mesajturId"
                    value={formik.values.mesajturId}
                    onChange={formik.handleChange}
                    error={Boolean(formik.errors.mesajturId)}
                    helperText={formik.errors.mesajturId}
                />
            </Grid>
            <Grid item md={4}>
                <MesajTipAutocomplete
                    disableClearable={true}
                    readonly={readOnly}
                    required={true}
                    label={translate(translatePath, "Mesaj Tipi")}
                    name="mesajtip"
                    value={formik.values.mesajtip}
                    onChange={(e) => {
                        if (!e.target?.value)
                            return;
                        formik.setFieldValue("fkAlanIds", "");
                        formik.handleChange(e);
                    }}
                    error={Boolean(formik.errors.mesajtip)}
                    helperText={formik.errors.mesajtip}
                />
            </Grid>
            {formik.values?.mesajtip === 1 && (
                <Grid item md={4}>
                    <ModulMultiAutocomplete
                        required={true}
                        limitTags={1}
                        yetkiBazliGetir={true}
                        readonly={readOnly}
                        label={translate(translatePath, "Modül")}
                        name="fkAlanIds"
                        value={formik.values.fkAlanIds}
                        onChange={formik.handleChange}
                        error={Boolean(formik.errors.fkAlanIds)}
                        helperText={formik.errors.fkAlanIds}
                    />
                </Grid>
            )}
            {formik.values?.mesajtip === 2 && (
                <Grid item md={4}>
                    <PersonelAutoCompleteMulti
                        readonly={readOnly}
                        label={translate(translatePath, "Personel")}
                        name="fkAlanIds"
                        value={formik.values.fkAlanIds}
                        onChange={formik.handleChange}
                        error={Boolean(formik.errors.fkAlanIds)}
                        helperText={formik.errors.fkAlanIds}
                    />
                </Grid>
            )}
            <Grid item>
                <TextField
                    required={true}
                    label={translate(translatePath, "Başlık")}
                    name="baslik"
                    value={formik.values.baslik}
                    onChange={formik.handleChange}
                    error={Boolean(formik.errors.baslik)}
                    helperText={formik.errors.baslik}
                    InputProps={{
                        readOnly: readOnly
                    }}
                />
            </Grid>
            <Grid item>
                <TextField
                    required={true}
                    multiline
                    rows={8}
                    label={translate(translatePath, "İçerik")}
                    name="icerik"
                    value={formik.values.icerik}
                    error={Boolean(formik.errors.icerik)}
                    helperText={formik.errors.icerik}
                    onChange={formik.handleChange}
                    InputProps={{
                        readOnly: readOnly,
                    }}
                />
            </Grid>
            {!readOnly && (
                <Grid item md={4} lg={3}>
                    <Button customType="save" disabled={!formik.dirty} loading={ekleState.isLoading || guncelleState.isLoading} onClick={saveHandler} />
                </Grid>
            )}
            <Grid item md={4} lg={3}>
                <Button customType="close" onClick={closeHandler} />
            </Grid>
        </Grid>
    );
};

export default MesajEkle;